import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

// import JS files
import useFetch from "../../context/useFetch";
import { useAuth } from "../../context/AuthContext";
import MuiTextFieldHook from "../mui/MuiTextFieldHook";
import MuiTextField from "../mui/MuiTextField";
import MuiTheme from "../mui/MuiTheme";

// import others files
import loginImg from "../../imgs/login.jpg";
import { currentCustomer } from "../../constants/constants";

const Login = (props) => {
  const navigate = useNavigate();

  const { authDispatch } = useAuth();
  const [openModal, setOpenModal] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm();

  const [postData, setPostData] = useState({});
  const [enterCaptchaValue, setEnterCaptchaValue] = useState("");
  console.log(enterCaptchaValue);
  const [captchaData, setCaptchaData] = useState({
    captcha_image: "",
    captcha_key: "",
  });
  const captchaApi = useFetch({
    method: "post",
    url: "api/captcha",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      console.log(res);
      setCaptchaData(res);
      setEnterCaptchaValue("");
    },
    errMessage: (mess) => {
      toast.error("دوباره تلاش کنید ", {
        position: toast.POSITION.TOP_CENTER,
      });
      captchaApi.reFetch();
    },
  });
  const loginApi = useFetch({
    method: "post",
    url: "login",
    noHeader: true,
    data: postData,
    argFunc: (res) => {
      authDispatch({
        type: "LOGIN",
        token: res.access_token,
        // refresh: res.refresh_token,
      });
      toast.success("ورود موفق", {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate("/");
    },
    errMessage: (mess) => {
      toast.error("ورود ناموفق", {
        position: toast.POSITION.TOP_CENTER,
      });
      captchaApi.reFetch();
    },
  });

  const onSubmit = (data) => {
    data["captcha_value"] = enterCaptchaValue;
    data["captcha_key"] = captchaData.captcha_key;
    console.log(enterCaptchaValue);
    setPostData(data);
    loginApi.reFetch();
  };
  return (
    <>
      <div class="h-screen relative login-background">
        <div class="fade-in bg-[#fff] rounded-xl shadow-xl w-5/6 md:w-3/4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 grid md:grid-cols-2 md:p-4">
          <div className=" flex flex-col justify-center items-center py-12">
            <div className=" flex flex-col items-center mb-6">
              <img src={currentCustomer.logo} alt="" className="w-1/4 md:w-1/2" />
              <span className="text-myblack-100 font-extrabold text-xl md:text-2xl mt-4 mb-8 md:mb-0">
                سامانه ثبت نام تکمیلی درمان
              </span>
            </div>
            <div className="w-3/4 md:mt-6">
              <form onSubmit={handleSubmit(onSubmit)}>
                <MuiTheme>
                  <div className="">
                    <MuiTextFieldHook
                      id="message"
                      label="نام کاربری"
                      variant="outlined"
                      size="small"
                      name="username"
                      control={control}
                      register={{
                        required: {
                          value: true,
                          message: "نام کاربری را وارد نمایید.",
                        },
                      }}
                      isLTR
                    />
                  </div>
                  <div className="mt-4 md:mt-8">
                    <MuiTextFieldHook
                      id="message"
                      label="رمز عبور"
                      variant="outlined"
                      size="small"
                      name="password"
                      control={control}
                      register={{
                        required: {
                          value: true,
                          message: "رمز عبور را وارد نمایید.",
                        },
                      }}
                      isLTR
                      type="password"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4 items-center mt-4 md:mt-8">
                    <MuiTextField
                      value={enterCaptchaValue}
                      onChange={(e) => setEnterCaptchaValue(e.target.value)}
                      id="outlined-basic"
                      label="کد امنیتی"
                      variant="outlined"
                      size="small"
                      name="captcha"
                      isLTR
                      type="captcha"
                      control={control}
                      register={{
                        required: {
                          value: true,
                          message: "کد امنیتی را وارد کنید",
                        },
                      }}
                    />
                    <img
                      className="w-full h-10"
                      src={`data:image/png;base64,${captchaData.captcha_image}`}
                    />
                  </div>
                </MuiTheme>

                <div className=" mt-6 flex justify-end">
                  <IconButton
                    aria-label="next"
                    type="submit"
                    className="login-icon-btn"
                  >
                    <ArrowBackIcon className="text-white" />
                  </IconButton>
                </div>
              </form>
            </div>
          </div>
          <div className="p-4  justify-center items-center hidden md:flex border-r border-slate-400 border-dashed my-16">
            <img src={loginImg} alt="" className="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
